import * as React from 'react';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import BounakirMessage from './BounakirMessage';
import { useHistory, useLocation } from 'react-router-dom';
import { TransitionProps } from '@mui/material/transitions';
import { useEffect, useState } from 'react';

const Transition = React.forwardRef(function Transition(
   props: TransitionProps & {
      children: React.ReactElement<any, any>;
   },
   ref: React.Ref<unknown>,
) {
   return <Slide direction="up" ref={ref} {...props} />;
});


const BounakirMessagePopup = ({ isOpened }: any) => {
   const [member, setMember] = useState<any>({});
   const history = useHistory();
   const location = useLocation();


   useEffect(() => {
      if (isOpened) {
         const { member }: any = location.state;
         setMember(JSON.parse(member));
      }
   }, []);


   return (
      <>
         <div>
            <Dialog
               sx={{ "& .MuiDialog-paper": { backgroundColor: "#f5f4f9" } }}
               className={"bounakirMessagePopup"}
               fullScreen
               TransitionComponent={Transition}
               open={isOpened}
               disableEscapeKeyDown={true}
               onClose={() => history.go(-2)}

            >
               <BounakirMessage {...member} />
            </Dialog>
         </div>
      </>


   )
}


export default BounakirMessagePopup;